export default function toArray(value) {
  if (value === null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter(function (item) {
      return item !== '';
    });
  }
  return value !== undefined && value !== '' ? [value] : [];
}